<!-- <div> -->
<form  [formGroup]="gridFormGroup" class="mt-4 pl-2">

<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="UVOZIZVODA.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <div class="form-group row">
    <div class="col-md-12">
      <yt-fw-grid-with-editing
        [Items]="items"
        [GridTableColumns]="gridTableColumns"  
        formControlName = "GridControl"    
        >
      </yt-fw-grid-with-editing>
      <div class="form-error" *ngIf="submitted && this.gridFormGroup.invalid">
        <span class="error-message" *ngIf="this.gridFormGroup.errors && this.gridFormGroup.errors.checkGrid && !this.gridFormGroup.errors.checkGrid.valid"><span translate="{{this.gridFormGroup.errors.checkGrid.message}}"></span></span>
      </div>
    </div>
  </div>
 
  </div>
  <div class="form-group modal-footer">
      <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end">
          <span class="input-group-append">
              <span *ngIf="loading" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
              <button type="submit" class="btn btn-primary" (click)="Save()" [disabled]="loading" >
                <!-- <span *ngIf="!loading">Sačuvaj</span>      -->
                <span>Sačuvaj</span>                  
              </button>
          </span>
      </div>
    <!-- <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button> -->
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>
</form>
<!-- </div> -->